import * as types from './action-types';
import _ from 'lodash';

export const selectPlayer = (player) => {
  return (dispatch) => {
    return dispatch(getPlayerStats(player.id))
      .then(() => dispatch(getPlayerShots(player.id)))
      .then(() => dispatch({type: types.SELECT_PLAYER, player}))
  }
};

export const setPlayerFilter = (filterText) => {
  return (dispatch) => {
    return dispatch({type: types.SET_PLAYER_FILTER, filterText});
  }
};

export const selectShotType = (shotType) => {
  return (dispatch) => {
    return dispatch({type: types.SELECT_SHOT_TYPE, shotType});
  }
};

export const selectShotsFiltered = (shotsFiltered) => {
  return (dispatch) => {
    return dispatch({type: types.SELECT_SHOTS_FILTERED, shotsFiltered});
  }
};

export const getPlayerList = () => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_PLAYER_LIST});

    return api.getPlayerList()
      .then(data => dispatch({
        type: types.RECEIVED_PLAYER_LIST,
        data
      }));
  }
};

export const getPlayerStats = (playerId) => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_PLAYER_STATS});

    return api.getPlayerStats(playerId)
      .then(data => dispatch({
        type: types.RECEIVED_PLAYER_STATS,
        data
      }));
  }
};

export const getPlayerShots = (playerId) => {
  return (dispatch, getState, api) => {
    dispatch({type: types.GET_PLAYER_SHOTS});

    return api.getPlayerShots(playerId)
      .then(data => dispatch({
        type: types.RECEIVED_PLAYER_SHOTS,
        data
      }));
  }
};

export const initializeData = () => {
  return (dispatch, getState) => {

    // Grab players list
    return dispatch(getPlayerList())
      .then(() => {

        // Then default selection to first player in sorted list
        const players = getState().players.list;
        const first = _.first(_.sortBy(players, ['team.name', 'name']));

        return dispatch(selectPlayer(first))
      });
  }
};


// WEBPACK FOOTER //
// ./src/redux/actions/index.js